import React from 'react';
import Button from 'react-bootstrap/Button';
import { GtmAnalyticsData, LinkModel } from '../../models/globals';
import { publishAnalyticsEvent } from '../../services/analytics';

interface EnrollNowButtonProps {
    addToCartLink: LinkModel;
    className?: string;
    showButton: boolean;
    id?: string;
    addToCartGtmAnalyticsData: GtmAnalyticsData | undefined;
}

const EnrollNowButton: React.FC<EnrollNowButtonProps> = ({
    addToCartLink: { name, url },
    className = '',
    showButton,
    addToCartGtmAnalyticsData,
    id,
}) => {
    if (!showButton) return null;

    return (
        <Button
            className={`${className} font-weight-bold px-5 text-uppercase`.trim()}
            href={url}
            id={id}
            onClick={async (event) => {
                event.preventDefault();

                try {
                    if (addToCartGtmAnalyticsData) {
                        await publishAnalyticsEvent(addToCartGtmAnalyticsData);
                    }
                } catch (e) {
                    console.error(e);
                } finally {
                    window.location.assign(url);
                }
            }}
            variant="success"
        >
            {name}
        </Button>
    );
};

export { EnrollNowButton, EnrollNowButtonProps };
